export const Legends = [
  // legacy mint function
  'function mint(uint256)',
  // mint function, since season 1
  'function mint(uint characterType, uint season)',
  'function spinWheel(uint256 random)',
  'function linkAndAcceptInvite(address INVITEE_V2_ACCOUNT, address INVITEE_EOA_OR_V1, address INVITER_V2, bytes signature)',
  'function invite(address)',
  'function getDailyReward()',
  'function claimXpFromFeedback(string)',
  'function claimBitrefillCode()',
  'function revealMascotLetter()'
]
